/**
 * «Más» — lo que no se usa a diario.
 *
 * Ninguna de estas pantallas desapareció; dejaron de ocupar un sitio en el menú
 * principal, donde competían por la atención con lo que sí se usa todos los
 * días. Están agrupadas por el momento en que a una persona le hacen falta, no
 * por la tabla en la que viven.
 */
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import {
  PieChart, CalendarCheck, RefreshCw, Calendar, Users, Home as HomeIcon,
  Globe, HelpCircle, Settings, Target,
} from "lucide-react";

const GROUPS = [
  {
    title: "Para entender tus números",
    items: [
      { to: "/analisis", label: "Tus números", hint: "Gráficas de en qué se te va", icon: PieChart },
      { to: "/metas", label: "Metas y límites", hint: "Ahorrar para algo, o ponerte un tope", icon: Target },
      { to: "/calendario", label: "Calendario", hint: "Todo lo que viene, mes a mes", icon: Calendar },
    ],
  },
  {
    title: "Una vez al mes",
    items: [
      { to: "/conciliacion", label: "Cierre de mes", hint: "Cuadrar con el banco y cerrar", icon: CalendarCheck },
      { to: "/suscripciones", label: "Suscripciones", hint: "Cobros que se repiten sin que lo notes", icon: RefreshCw },
    ],
  },
  {
    title: "Tu familia",
    items: [
      { to: "/familia", label: "Familia", hint: "Compartir cuentas con quien vive contigo", icon: HomeIcon },
      { to: "/aprobaciones", label: "Permisos de compra", hint: "Pedir el visto bueno antes de gastar", icon: Users },
    ],
  },
  {
    title: "Otras cosas",
    items: [
      { to: "/comisiones", label: "Comisiones del banco", hint: "Cuánto cobra transferir", icon: Globe },
      { to: "/ayuda", label: "Ayuda", hint: "Cómo funciona todo", icon: HelpCircle },
      { to: "/perfil", label: "Tu perfil", hint: "Nombre, correo, plan", icon: Settings },
    ],
  },
];

export default function MoreSheet({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#15141b] border-white/10 text-white sm:max-w-md max-h-[88vh] overflow-y-auto"
        data-testid="more-sheet">
        <DialogTitle className="text-xl font-bold text-white">Más cosas</DialogTitle>
        <DialogDescription className="text-slate-400 text-[13px]">
          Lo que no necesitas todos los días.
        </DialogDescription>

        <div className="space-y-5 mt-2">
          {GROUPS.map(g => (
            <section key={g.title}>
              <h3 className="text-[12px] uppercase tracking-[0.14em] text-slate-500 font-bold mb-2">
                {g.title}
              </h3>
              <ul className="space-y-1.5">
                {g.items.map(it => (
                  <li key={it.to}>
                    <Link to={it.to} onClick={() => onOpenChange(false)}
                      data-testid={`more-${it.to.replace("/", "")}`}
                      className="flex items-center gap-3 p-3 rounded-2xl bg-white/[0.03] border border-white/10 hover:bg-white/[0.07] min-h-14">
                      <span className="w-9 h-9 rounded-xl bg-white/[0.06] flex items-center justify-center shrink-0">
                        <it.icon className="w-[17px] h-[17px] text-slate-300" aria-hidden="true" />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-[15px] font-medium text-white truncate">{it.label}</span>
                        <span className="block text-[12px] text-slate-400 truncate">{it.hint}</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
